import React, { createContext, useContext, useState, useCallback } from 'react';

const CURRENCIES = {
  USD: { symbol: '$', code: 'USD', rate: 1, decimals: 2, locale: 'en-US' },
  MXN: { symbol: '$', code: 'MXN', rate: 17.5, decimals: 2, locale: 'es-MX' },
  CAD: { symbol: 'C$', code: 'CAD', rate: 1.36, decimals: 2, locale: 'en-CA' },
  GBP: { symbol: '£', code: 'GBP', rate: 0.79, decimals: 2, locale: 'en-GB' },
  EUR: { symbol: '€', code: 'EUR', rate: 0.92, decimals: 2, locale: 'de-DE' },
  CHF: { symbol: 'CHF', code: 'CHF', rate: 0.88, decimals: 2, locale: 'de-CH' },
  CNY: { symbol: '¥', code: 'CNY', rate: 7.25, decimals: 2, locale: 'zh-CN' },
  JPY: { symbol: '¥', code: 'JPY', rate: 150, decimals: 0, locale: 'ja-JP' },
  COP: { symbol: '$', code: 'COP', rate: 4200, decimals: 0, locale: 'es-CO' },
  BRL: { symbol: 'R$', code: 'BRL', rate: 5.15, decimals: 2, locale: 'pt-BR' },
};

const CurrencyContext = createContext();

export function CurrencyProvider({ children }) {
  const [currencyCode, setCurrencyCode] = useState(
    () => localStorage.getItem('blackorex_currency') || 'USD'
  );

  const currency = CURRENCIES[currencyCode] || CURRENCIES.USD;

  const setCurrency = useCallback((code) => {
    if (CURRENCIES[code]) {
      setCurrencyCode(code);
      localStorage.setItem('blackorex_currency', code);
    }
  }, []);

  const formatCurrency = useCallback((amountUSD) => {
    if (amountUSD == null || isNaN(amountUSD)) return `${currency.symbol}0`;
    const converted = amountUSD * currency.rate;
    const formatted = converted.toLocaleString('en-US', {
      minimumFractionDigits: currency.decimals,
      maximumFractionDigits: currency.decimals,
    });
    return `${currency.symbol}${formatted}`;
  }, [currency]);

  const convertAmount = useCallback((amountUSD) => {
    if (amountUSD == null || isNaN(amountUSD)) return 0;
    return amountUSD * currency.rate;
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{
      currency,
      currencyCode,
      setCurrency,
      formatCurrency,
      convertAmount,
      currencies: CURRENCIES,
    }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within CurrencyProvider');
  return ctx;
}

export { CURRENCIES };
